/**
 * Under which limb of § 124 SGB V a Leistungserbringergruppe is admitted.
 *
 * Load-bearing rather than decorative: the § 124 Abs. 5 groups (Krankenhaus,
 * Kurbetrieb, Sonstige therapeutische Heilperson) bill the **same** § 125
 * contract as the zugelassene Leistungserbringer, but under a different
 * Sondertarif — which is exactly why the Sondertarif cannot be read as a
 * Vertragsart (#1413 § 17.2).
 */
export var Zulassung;
(function (Zulassung) {
    /** Zugelassener Leistungserbringer, § 124 Abs. 1 Nr. 1. */
    Zulassung["ABS_1"] = "ABS_1";
    /** Krankenhaus, Kurbetrieb, sonstige therapeutische Heilperson — § 124 Abs. 5. */
    Zulassung["ABS_5"] = "ABS_5";
})(Zulassung || (Zulassung = {}));
//# sourceMappingURL=zulassung.enum.js.map